export const AbpPolicies = {
  // Jobs (imports et tâches d'administration)
  JOBS_MANAGER: "BackOffice.JobsManager",

  // Dashboard permissions
  DASHBOARD_HOST: "BackOffice.Dashboard.Host",
  DASHBOARD_TENANT: "BackOffice.Dashboard.Tenant",
  DASHBOARD_STATS: "BackOffice.Dashboard.Statistiques",

  // Contrats permissions
  CONTRATS_DEFAULT: "BackOffice.Contrats",
  CONTRATS_READ: "BackOffice.Contrats.Read",
  CONTRATS_CREATE: "BackOffice.Contrats.Create",
  CONTRATS_MANAGE: "BackOffice.Contrats.Manage",

  // Devis permissions
  DEVIS_DEFAULT: "BackOffice.Devis",
  DEVIS_CREATE: "BackOffice.Devis.Create",
  DEVIS_READ: "BackOffice.Devis.Read",
  DEVIS_DELETE: "BackOffice.Devis.Delete",
  DEVIS_MANAGE: "BackOffice.Devis.Manage",

  // Simulations permissions
  SIMU_DEFAULT: "BackOffice.Simulations",
  SIMU_READ: "BackOffice.Simulations.Read",
  SIMU_MANAGE: "BackOffice.Simulations.Manage",

  // Acteurs permissions
  ACTEURS_DEFAULT: "BackOffice.Acteurs",
  ACTEURS_ASSURE: "BackOffice.Acteurs.Assure",
  ACTEURS_SOUSCRIPTEUR: "BackOffice.Acteurs.Souscripteur",
  ACTEURS_COURTIER: "BackOffice.Acteurs.Courtier",

  // Leads permissions
  LEADS_DEFAULT: "BackOffice.Leads",
  LEADS_READ: "BackOffice.Leads.Read",
  LEADS_MANAGE: "BackOffice.Leads.Manage",

  // Prélèvements HBS permissions
  PRELEVEMENTS_HBS_READ: "BackOffice.PrelevementsHbs.Read",
  PRELEVEMENTS_HBS_MANAGE: "BackOffice.PrelevementsHbs.Manage",

  // Liste des prélèvements (admin)
  ADMIN_PRELEVEMENTS_READ: "BackOffice.AdminPrelevements.Read",

  // Listes admin (toutes plateformes) permissions
  ADMIN_CONTRATS_READ: "BackOffice.AdminContrats.Read",
  ADMIN_DEVIS_READ: "BackOffice.AdminDevis.Read",
  ADMIN_SIMULATIONS_READ: "BackOffice.AdminSimulations.Read",

  // Clients permissions
  CLIENTS_READ: "BackOffice.Clients.Read",
  ADMIN_CLIENTS_READ: "BackOffice.AdminClients.Read",

  // Courtiers permissions
  COURTIERS_READ: "BackOffice.Courtiers.Read",
  ADMIN_COURTIERS_READ: "BackOffice.AdminCourtiers.Read",

  // Journal des connexions (admin)
  ADMIN_CONNEXIONS_READ: "BackOffice.AdminConnexions.Read",
  ATELIER_ROLES: "BackOffice.AtelierRoles",
  ATELIER_ROLES_MANAGE: "BackOffice.AtelierRoles.Manage",

  // Impersonation (« se connecter en tant que ») — permission ABP Identity,
  // accordée au rôle admin par ImpersonationDataSeederContributor.
  IMPERSONATE_USER: "AbpIdentity.Users.Impersonation",

  // Gestionnaires permissions (natures PM)
  GESTIONNAIRES_CREATE: "BackOffice.Gestionnaires.Create",

  // MIA permissions (natures PM)
  MIAS_READ: "BackOffice.Mias.Read",
  MIAS_CREATE: "BackOffice.Mias.Create",
  MIAS_UPDATE: "BackOffice.Mias.Update",

  // PIM permissions (natures PM — Professionnel de l'Immobilier, comme MIA sans ORIAS)
  PIMS_READ: "BackOffice.Pims.Read",
  PIMS_CREATE: "BackOffice.Pims.Create",
  PIMS_UPDATE: "BackOffice.Pims.Update",

  // Validations de devis (brique Valideur, Portail Gestion) : Read = lire les
  // demandes adressées au compte, Manage = re-tarifer et répondre
  VALIDATIONS_READ: "BackOffice.Validations.Read",
  VALIDATIONS_MANAGE: "BackOffice.Validations.Manage",

  // Contrats de groupe (lecture — portée par les briques Consultation portefeuille
  // orga, Souscription plateforme et Consultation porteur de risque)
  CONTRATS_DE_GROUPE_READ: "BackOffice.ContratsDeGroupes.Read",
  // Contrats de groupe (création côté courtier — refusée au rôle MIA)
  CONTRATS_DE_GROUPE_CREATE_OWN: "BackOffice.ContratsDeGroupes.CreateOwn",
  // Contrats de groupe (création côté compagnie — rôle Plateforme ; le backend
  // force le scope Plateforme sur l'OU possédée par la PM principale)
  CONTRATS_DE_GROUPE_CREATE: "BackOffice.ContratsDeGroupes.Create",

  // GED (lecture des documents — accordée aux briques de consultation, pas à
  // Conception d'offre ni Souscription plateforme)
  DOCUMENTS_READ: "BackOffice.Documents.Read",

  // Biens immobiliers / parcs (onglet « Biens immobiliers » de la fiche client).
  // ParcImmobilier n'a pas de .Read côté back : la lecture passe par le Default
  // (BackOfficePermissions.ParcImmobilier.Default = "BackOffice.ParcImmobilier").
  BIEN_IMMO_READ: "BackOffice.BienImmobilier.Read",
  PARC_IMMO_DEFAULT: "BackOffice.ParcImmobilier",

  // Tunnels / Produits (listes admin) permissions
  ADMIN_TUNNELS_READ: "BackOffice.AdminTunnels.Read",
  // Duplication et suppression d'un tunnel — écran admin : le back revérifie le rôle
  // à l'exécution
  ADMIN_TUNNELS_DUPLICATE: "BackOffice.AdminTunnels.Duplicate",
  ADMIN_TUNNELS_DELETE: "BackOffice.AdminTunnels.Delete",
  // Création d'un tunnel : rattachée au groupe Tunnels, pas à AdminTunnels
  TUNNELS_CREATE: "BackOffice.Tunnels.Create",
  ADMIN_PRODUITS_READ: "BackOffice.AdminProduits.Read",

  // Variables des formules de tarification : une seule permission couvre l'ajout, la
  // modification et le retrait d'une valeur de variable sur un tunnel
  EXPRESSIONS_VARIABLES_DEFINED: "BackOffice.Expressions.Variables.Defined"
} as const;

// Groupes de permissions pour faciliter l'usage
export const PermissionGroups = {
  DASHBOARD: [
    AbpPolicies.DASHBOARD_HOST,
    AbpPolicies.DASHBOARD_TENANT,
    AbpPolicies.DASHBOARD_STATS
  ],
  CONTRACTS: [
    AbpPolicies.CONTRATS_DEFAULT,
    AbpPolicies.CONTRATS_READ,
    AbpPolicies.CONTRATS_CREATE,
    AbpPolicies.CONTRATS_MANAGE
  ],
  QUOTES: [
    AbpPolicies.DEVIS_DEFAULT,
    AbpPolicies.DEVIS_READ,
    AbpPolicies.DEVIS_CREATE,
    AbpPolicies.DEVIS_DELETE,
    AbpPolicies.DEVIS_MANAGE
  ],
  SIMULATIONS: [
    AbpPolicies.SIMU_DEFAULT,
    AbpPolicies.SIMU_READ,
    AbpPolicies.SIMU_MANAGE
  ],
  ACTORS: [
    AbpPolicies.ACTEURS_DEFAULT,
    AbpPolicies.ACTEURS_ASSURE,
    AbpPolicies.ACTEURS_SOUSCRIPTEUR,
    AbpPolicies.ACTEURS_COURTIER
  ],
  LEADS: [
    AbpPolicies.LEADS_DEFAULT,
    AbpPolicies.LEADS_READ,
    AbpPolicies.LEADS_MANAGE
  ]
} as const;
